import { FolderPlusIcon } from './FolderPlusIcon';

/**
 * author: Austin Andrews
 * id BAE32170-6509-4D1F-A6A5-A2FD1A0C679B
 * name folder-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-plus.svg
 * tags
 * - Files / Folders 
 */
export const CreateNewFolderIcon = FolderPlusIcon;
export default CreateNewFolderIcon